import { render } from "./PaperSmart.vue?vue&type=template&id=8dcc3362"
import script from "./PaperSmart.vue?vue&type=script&lang=js"
export * from "./PaperSmart.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__